import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n, { getLang } from '@/utils/lang'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/index/index'),
    name: 'Index',
    meta: { title: 'ホームページ', key: 'home', keepAlive: true }
  },
  {
    path: '/home',
    component: () => import('@/views/index/index'),
    name: 'ホームページ',
    meta: { title: 'ホームページ', key: 'home', keepAlive: true }
  },
  {
    path: '/about',
    component: () => import('@/views/aboutus/index'),
    name: 'about',
    meta: { title: '私たちについて', key: 'about', keepAlive: true }
  },
  {
    path: '/relation',
    component: () => import('@/views/relation/index'),
    name: 'relation',
    meta: { title: '私たちについて', key: 'relation', keepAlive: true }
  },

  {
    path: '/latestUpdates',
    component: () => import('@/views/latestUpdates/index'),
    name: 'latestUpdates',
    meta: { title: '最新のプッシュ', key: 'latestUpdates', keepAlive: true }
  },
  {
    path: '/push-details/:index',
    component: () => import('@/views/pushDetails/index'),
    name: 'PushDetails',
    meta: { title: '最新のプッシュ', key: 'pushDetails' }
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  },
  routes
})

//处理路由标题国际化
const getPageTitle = (i18n, meta) => {
  // i18n.locale = 'zhf'
  // let lang = getLang()
  // i18n.locale = localStorage.getItem('language') || lang
  // const hasKey = i18n.te(`routeTitle.${meta.key}`)
  // const title = i18n.t(`routeTitle.${meta.key}`)
  // if (hasKey) {
  //   return title
  // }
  return meta.title
}

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  if (location.split('?')[0] === window.location.pathname) {
    originalPush.call(this, location).catch(err => err)
    window.location.reload()
  } else {
    return originalPush.call(this, location).catch(err => err)
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = getPageTitle(i18n, to.meta)
  }
  return next()
})

export default router
